import { AfterViewInit, Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ChartType, ChartTypeHighChart } from '../../../common';
import { SkeletonChartBase } from '../../../common/Models/SkeletonChartBase';

@Component({
  selector: 'skc-chart-wrapper',
  templateUrl: './chart-wrapper.component.html',
  styleUrls: ['./chart-wrapper.component.less']
})
export class ChartWrapperComponent extends SkeletonChartBase implements OnInit, AfterViewInit {
  @ViewChildren('myCanvas') myCanvasList: QueryList<ElementRef>;
  // @Input('skc-auto-detection') autoDetection;
  currentChartFound: ChartType;
  myCanvas;

  constructor() {
    super();
  }

  ngOnInit() {}

  private autoDetectChart() {
    const chartTypeFounded = this.verifyChartLib();
    if (!chartTypeFounded) {
      console.log('Error, the chart type is not supported');
    } else {
      this.currentChartFound = chartTypeFounded;
    }
  }

  private verifyChartLib() {
    let chartTypeFounded = this.verifyChartJSLib();
    if (!chartTypeFounded) {
      chartTypeFounded = this.verifyHighChartsLib();
    }
    return chartTypeFounded;
  }

  ngAfterViewInit(): void {}

  private verifyChartJSLib() {
    const chartKey = 'chart-type="';
    const chartTypeIndex = this.myCanvas.nativeElement.innerHTML.search(chartKey);
    if (chartTypeIndex !== -1) {
      return this.verifyChartTypeInChartJs(chartTypeIndex, chartKey.length);
    }
  }

  private verifyChartTypeInChartJs(chartTypeIndex, keyLenght) {
    const restOfInnerHtml = this.myCanvas.nativeElement.innerHTML.substring(chartTypeIndex + keyLenght);
    const lastCharater = restOfInnerHtml.search('"');
    const chartTypeFounded = restOfInnerHtml.substring(0, lastCharater);
    return chartTypeFounded;
  }

  private verifyHighChartsLib() {
    // const chartKey = 'highcharts-line-series';
    let chartsSupported = '';
    Object.values(ChartTypeHighChart).forEach(x => (chartsSupported += '(' + x + ')?'));
    const chartKey = 'highcharts-' + chartsSupported + '-series';
    const indexHighchartsKeyWord = this.myCanvas.nativeElement.innerHTML.match(chartKey);
    if (indexHighchartsKeyWord !== null) {
      return this.verifyChartTypeInHighCharts(indexHighchartsKeyWord.index, indexHighchartsKeyWord[0].length);
    }
  }

  private verifyChartTypeInHighCharts(indexHighchartsKeyWord, keyLenght) {
    const rawChartType = this.myCanvas.nativeElement.innerHTML.substring(
      indexHighchartsKeyWord,
      indexHighchartsKeyWord + keyLenght
    );
    return rawChartType.split('-')[1];
  }
}
